import { defineComponent as _defineComponent } from 'vue'
import CountriesListByRegion from '@/components/countries-list/CountriesListByRegion.vue';
import type { WebLocale } from '@/enums/web-locale';
import { Region } from '@/interfaces/locale-details';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountriesList',
  setup(__props) {

const { changeWebLocale, setPersistentWebLocale } = useLanguageStore();
const router = useRouter();

async function setCountry(webLocale: WebLocale) {
	await changeWebLocale(webLocale);

	await setPersistentWebLocale(webLocale);
	router.push({ name: 'app.titles.popular.list' });
}

return { __sfc: true,changeWebLocale, setPersistentWebLocale, router, setCountry, CountriesListByRegion, Region }
}

})